import script from "./Appmessage.vue?vue&type=script&setup=true&lang=js"
export * from "./Appmessage.vue?vue&type=script&setup=true&lang=js"

import "./Appmessage.vue?vue&type=style&index=0&id=53cc2fdc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53cc2fdc"]])

export default __exports__